import { FilterDeclaration } from '../../features/filter/types'

// функция принимает параметрами дефолтные фильтра и relatedFilters
// сравнивает их длину
export const compareFiltersLength = (declaration: FilterDeclaration | null, relatedFilters: any) => {
  const declarationLength = Object.keys(declaration?.sections || {}).length
  const relatedFiltersLength = Object.keys(relatedFilters?.sections || {}).length

  return relatedFiltersLength !== declarationLength && declarationLength > 0 && relatedFiltersLength > 0
}
